import React from 'react';
import * as R from 'ramda';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature fleet-profile
import CompensationGroupFormGroupTable from '../components/compensation-group-table';
//////////////////////////////////////////////////

export const compensationGroupSettings = {
  groupName: 'compensationGroup',
  Component: ({
    primaryObjectGuid,
    primaryObjectGuidKey,
    ...rest
  }) => (
    <CompensationGroupFormGroupTable
      {...rest}
      groupName='compensationGroup'
      primaryObjectGuid={primaryObjectGuid}
      formGroupTitleArr={['titles:compensation-group', 'Compensation Group']}
      primaryObjectGuidKey={G.ifElse(
        R.equals(primaryObjectGuidKey, GC.FIELD_DRIVER_GUID),
        GC.FIELD_DRIVER_GUID,
        GC.FIELD_FLEET_VENDOR_GUID,
      )}
    />
  ),
};
